module.exports = __webpack_public_path__ + "static/media/decision-blue.781e9a9c.svg";